import { render, staticRenderFns } from "./ModalItemOS.vue?vue&type=template&id=e7acf6be&scoped=true"
import script from "./ModalItemOS.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalItemOS.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7acf6be",
  null
  
)

export default component.exports